import React, { createContext, ReactNode, useContext } from 'react'
import useIssuesApi from './useIssuesApi'

interface IIssuesContextState extends ReturnType<typeof useIssuesApi> {}

const issuesDefaultState: IIssuesContextState = {
  loadingIssueTypes: false,
  options: {
    faults: [],
    reasons: [],
    types: [],
    categories: [],
  },
  data: {
    faults: [],
    reasons: [],
    types: [],
    categories: [],
  },
  refetchIssueTypes: () => Promise.resolve(null),
}

export const IssuesContext = createContext(issuesDefaultState)

export const IssuesContextProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const state = useIssuesApi()
  return <IssuesContext.Provider value={state}>{children}</IssuesContext.Provider>
}

export const useIssuesContext = () => useContext(IssuesContext)
